module.exports = __webpack_public_path__ + "img/dl7.5b6980fd.png";